/**
 * Unauthorized Page
 * Shown when an authenticated user tries to access a route they lack permission for.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="text-8xl mb-6">🚫</div>
        <h1 className="text-4xl font-bold text-white mb-3">Access Denied</h1>
        <p className="text-gray-400 mb-2 text-lg">
          You don't have permission to view this page.
        </p>
        {user && (
          <p className="text-gray-500 text-sm mb-8">
            Your current role is <span className="font-semibold text-yellow-400">{user.role}</span>.
            Admin or Superadmin access is required.
          </p>
        )}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate('/lobby')}
            className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition-colors"
          >
            Go to Lobby
          </button>
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white rounded-lg font-semibold transition-colors"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
